import React from "react";

const Users = () => {
  return (
    <div>
      <h1>Users</h1>
      <p>Content of the users page...</p>
    </div>
  );
};

export default Users;
